import React, { FC, useCallback } from 'react';

import { Popup } from 'devextreme-react/popup';

import ModalFooter from 'components/appModalFooter';

import { useDeleteContractorIndividualMutation } from 'bus/contractorIndividual/services/services';

type DetailModalRoleProps = {
  id: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const DetailModalRole: FC<DetailModalRoleProps> = ({ changeVisible, id, refresh, visible }) => {
  const [deleteContractorIndividual, { isLoading }] = useDeleteContractorIndividualMutation();

  const handleSubmit = useCallback(
    async (e: any) => {
      e.preventDefault && e.preventDefault();
      await deleteContractorIndividual({ id: id! });
      refresh();
      changeVisible(false);
    },
    [changeVisible, deleteContractorIndividual, id, refresh],
  );

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтвердите действие"
        width={400}
        height={160}
      >
        <div className="modal-block">
          <div className="modal-block__content">Вы действительно хотите удалить физ. лицо?</div>

          <ModalFooter
            useSubmitBehavior={true}
            handleSubmit={handleSubmit}
            hideModal={() => changeVisible(false)}
            textConfirm="Удалить"
            typeConfirm="danger"
            disabledSubmit={isLoading}
          />
        </div>
      </Popup>
    </div>
  );
};

export default DetailModalRole;
